<template>
  <div class="base_box">
    <baseSearch @search="searchFun" @reset="resetFun" :list="searchFrom">
    </baseSearch>

    <div class="mt10 base_content" style="border-radius: 0">
      <div class="order_type">
        <div
          @click="
            search.post.status = 0;
            initList();
          "
          :class="search.post.status == 0 ? 'order_type_active' : ''"
          class="order_type_item"
        >
          全部({{ search.count_list.count }})
        </div>
        <div
          @click="
            search.post.status = 1;
            initList();
          "
          :class="search.post.status == 1 ? 'order_type_active' : ''"
          class="order_type_item"
        >
          待审核({{ search.count_list.count1 }})
        </div>
        <div
          @click="
            search.post.status = 2;
            initList();
          "
          :class="search.post.status == 2 ? 'order_type_active' : ''"
          class="order_type_item"
        >
          待打款({{ search.count_list.count2 }})
        </div>
        <div
          @click="
            search.post.status = 3;
            initList();
          "
          :class="search.post.status == 3 ? 'order_type_active' : ''"
          class="order_type_item"
        >
          已完成({{ search.count_list.count3 }})
        </div>
        <div
          @click="
            search.post.status = 4;
            initList();
          "
          :class="search.post.status == 4 ? 'order_type_active' : ''"
          class="order_type_item"
        >
          已拒绝({{ search.count_list.count4 }})
        </div>
      </div>
      <table class="order_table" border="0" cellspacing="0" cellpadding="0">
        <tr>
          <th align="left">会员信息</th>
          <th align="center">提现单号</th>
          <th align="center">分红类型</th>
          <th align="center">提现方式</th>
          <th align="center">账号信息</th>
          <th align="center">打款方式</th>
          <th align="center">申请金额</th>
          <th align="center">手续费</th>
          <th align="center">实际到账</th>
          <th align="center">申请时间</th>
          <th align="center">到账时间</th>
          <th align="center">状态</th>
          <th align="center">操作</th>
        </tr>
        <tbody v-if="search.table.length <= 0">
          <tr>
            <td colspan="13" style="padding: 0; border: 0">
              <div
                style="
                  padding: 30px;
                  border: 0;
                  width: 100%;
                  text-align: center;
                  color: #999;
                "
              >
                暂无数据
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-for="item in search.table" :key="item.id">
          <tr>
            <td align="center">
              <div style="display: flex; align-items: center">
                <img
                  style="
                    width: 30px;
                    height: 30px;
                    margin-right: 10px;
                    border-radius: 50%;
                  "
                  :src="(item.user && item.user.avatar && item.user.avatar.url) ? item.user.avatar.url : require('@/static/img/people.png')"
                  alt=""
                  v-if="item.user"
                />
                <img
                  style="
                    width: 30px;
                    height: 30px;
                    margin-right: 10px;
                    border-radius: 50%;
                  "
                  src="@/static/img/people.png"
                  alt=""
                  v-else
                />
                <div style="display: flex; align-items: center; text-align: left">
                  <div class="user_right_name" v-if="item.user">
                    {{ item.user.true_name || item.user.nick_name }}/{{ item.user.mobile }}
                  </div>
                  <div v-else>/-</div>
                </div>
              </div>
            </td>

            <!-- 提现单号 -->
            <td align="center">{{ item.order_sn }}</td>

            <!-- 分红类型 -->
            <td align="center">
              <span v-if="item.poolprofit_type == 1">店长</span>
              <span v-else-if="item.poolprofit_type == 2">合伙人</span>
              <span v-else>-</span>
            </td>

            <!-- 提现方式 -->
            <td align="center" style="font-weight: bold">
              <span style="color: #00ba49" v-if="item.withdrawal_type == 1">微信钱包</span>
              <span style="color: #006aff" v-else-if="item.withdrawal_type == 2">支付宝</span>
              <span style="color: #006aff" v-else-if="item.withdrawal_type == 3">商城余额</span>
              <span style="color: #006aff" v-else-if="item.withdrawal_type == 4">银行卡</span>
              <span v-else>-</span>
            </td>

            <!-- 账号信息 -->
            <td align="center">
              <div v-if="item.alipay_name">
                <p>{{ item.alipay_name }}/{{ item.alipay_account }}</p>
              </div>
              <div v-else>-</div>
            </td>

            <!-- 打款方式 -->
            <td align="center" style="font-weight: bold">
              <span style="color: #00ba49" v-if="item.withdrawal_type == 1">微信钱包</span>
              <span style="color: #006aff" v-else-if="item.withdrawal_type == 2">支付宝</span>
              <span style="color: #006aff" v-else-if="item.withdrawal_type == 3">商城余额</span>
              <span style="color: #006aff" v-else-if="item.withdrawal_type == 4">银行卡</span>
              <span v-else>-</span>
            </td>

            <td align="center">{{ item.apply_money || 0 }}</td>
            <td align="center">{{ item.service_money || 0 }}</td>
            <td align="center">{{ item.money || 0 }}</td>
            <td align="center">{{ item.check_time || "-" }}</td>
            <td align="center">{{ item.receive_time || item.pay_time || "-" }}</td>

            <!-- 状态 -->
            <td align="center">
              <span v-if="item.status == 0">待审核</span>
              <span v-else-if="item.status == 1">待打款</span>
              <span v-else-if="item.status == 2" style="color: #f56c6c">已拒绝</span>
              <span v-else-if="item.status == 3" style="color: #00ba49">已完成</span>
              <span v-else-if="item.status == 5" style="color: #006aff">转账中</span>
              <span v-else-if="item.status == 6" style="color: #f56c6c">转账失败</span>
              <span v-else>-</span>
            </td>

            <!-- 操作 -->
            <td align="center">
              <!-- 更新微信打款状态 -->
              <div
                style="display: inline-block"
                v-if="
                  (item.status == 2 || item.status == 3 || item.status == 5) &&
                  item.withdrawal_type == 1
                "
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="更新微信打款状态"
                  placement="top"
                >
                  <div
                    @click="refreshFun(item.transfer_bill_id)"
                    class="but_primary"
                  >
                    更新
                  </div>
                </el-tooltip>
              </div>
              <!-- 撤销转账 -->
              <div
                style="display: inline-block"
                v-if="item.status == 5 && item.withdrawal_type == 1"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="用户待收款状态，撤回该笔打款"
                  placement="top"
                >
                  <div
                    @click="closeFun(item.transfer_bill_id)"
                    class="but_primary"
                  >
                    撤销
                  </div>
                </el-tooltip>
              </div>
              <!-- 通过 -->
              <div
                v-if="item.status == 0"
                @click="yesFun(item.id)"
                class="but_primary"
              >
                通过
              </div>
              <!-- 拒绝（待审核） -->
              <div
                v-if="item.status == 0"
                class="but_primary"
                @click="noFun(item.id)"
              >
                无效
              </div>
              <!-- 打款 -->
              <div
                v-if="item.status == 1"
                @click="yesHand(item.id)"
                class="but_primary"
              >
                打款
              </div>
              <!-- 拒绝打款 -->
              <div
                v-if="item.status == 1"
                @click="refusePay(item.id)"
                class="but_primary"
              >
                拒绝
              </div>
              <div
                v-if="
                  (item.status == 2 || item.status == 3 || item.status == 5) &&
                  (item.withdrawal_type == 2 || item.withdrawal_type == 3 || item.withdrawal_type == 4)
                "
              >
                -
              </div>
              <div v-if="item.status == 4">-</div>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="search.total > 10" class="text_center mt40 mb20">
        <el-pagination
          background
          @current-change="tablePageFun"
          :current-page="search.post.page"
          layout="prev, pager, next"
          :total="search.total"
        >
        </el-pagination>
      </div>
    </div>

    <baseModal
      width="430px"
      title="拒绝原因"
      @sureFun="addSureFun"
      @cancalFun="
        () => {
          reason.show = false;
        }
      "
      :dialogVisible="reason.show"
    >
      <template #content>
        <el-form class="mt20" label-width="80px">
          <el-form-item label="拒绝原因">
            <el-input
              size="small"
              placeholder="请输入拒绝原因"
              v-model="reason.text"
              type="text"
              style="width: 300px"
            ></el-input>
          </el-form-item>
        </el-form>
      </template>
    </baseModal>
  </div>
</template>

<script>
import { eltips } from "@/util/util.js";
import baseSearch from "@/components/common/baseSearch.vue";
import baseModal from "@/components/common/baseModal.vue";

export default {
  components: {
    baseSearch,
    baseModal,
  },
  data() {
    return {
      searchFrom: [
        {
          type: "input",
          Field: "nickname",
          label: "会员姓名",
          placeholder: "请输入会员姓名",
        },
        {
          type: "input",
          Field: "mobile",
          label: "手机号",
          placeholder: "请输入手机号",
        },
        {
          type: "select",
          Field: "withdrawal_type",
          label: "提现方式",
          style: { width: "200px" },
          options: [
            { value: "", label: "全部" },
            { value: "1", label: "微信钱包" },
            { value: "2", label: "支付宝" },
            { value: "3", label: "商城余额" },
            { value: "4", label: "银行卡" },
          ],
        },
        {
          type: "select",
          Field: "poolprofit_type",
          label: "分红类型",
          style: { width: "200px" },
          options: [
            { value: "", label: "全部" },
            { value: "1", label: "店长" },
            { value: "2", label: "合伙人" },
          ],
        },
        {
          type: "datePicker",
          Field: "created_at",
          label: "申请时间",
          style: { width: "320px" },
        },
      ],
      search: {
        post: {
          status: 0,
          keyword: "",
          page: 1,
          limit: 10,
          nickname: "",
          mobile: "",
          withdrawal_type: "",
          poolprofit_type: "",
          created_at: [],
          start_time: "",
          end_time: "",
        },
        loading: false,
        total: 0,
        table: [],
        count_list: {
          count: 0,
          count1: 0,
          count2: 0,
          count3: 0,
          count4: 0,
        },
      },
      reason: {
        id: "",
        text: "",
        show: false,
      },
      type: "",
    };
  },
  created() {
    this.getList();
  },
  methods: {
    refreshFun(e) {
      let _this = this;
      if (!e) {
        eltips("转账单据ID为空", "error");
        return;
      }
      _this.axios
        .post("/api/weishop/admin/plugin/wechat-transfer/query/" + e)
        .then((res) => {
          if (res.code == 200) {
            eltips(res.msg, "success");
            _this.getList();
          } else {
            eltips(res.msg, "error");
          }
        });
    },
    closeFun(e) {
      let _this = this;
      if (!e) {
        eltips("转账单据ID为空", "error");
        return;
      }
      _this.$confirmDialog({
        title: "重要提示",
        content:
          '<div style="font-size:16px;display:flex;align-items: center;justify-content: center;">确认撤销该笔打款金额</div>',
        cancelText: "取消",
        confirmText: "确定",
        showClose: true,
        width: "500px",
        success: (res) => {
          if (res.confirm) {
            _this.axios
              .post("/api/weishop/admin/plugin/wechat-transfer/query/" + e)
              .then((res) => {
                if (res.code == 200) {
                  eltips(res.msg, "success");
                  _this.getList();
                } else {
                  eltips(res.msg, "error");
                }
              });
          }
        },
      });
    },
    initList() {
      this.search.table = [];
      this.search.total = 0;
      this.getList();
    },
    changeStatus(status) {
      this.search.post.status = status;
      this.search.post.page = 1;
      this.getList();
    },
    searchFun(e) {
      let _this = this;
      _this.search.post.page = 1;
      _this.search.post = { ..._this.search.post, ...e };
      if (_this.search.post.created_at && _this.search.post.created_at.length == 2) {
        _this.search.post.start_time = _this.search.post.created_at[0];
        _this.search.post.end_time = _this.search.post.created_at[1];
      } else {
        _this.search.post.start_time = "";
        _this.search.post.end_time = "";
      }
      _this.getList();
    },
    resetFun() {
      this.search.post = {
        status: 0,
        keyword: "",
        page: 1,
        limit: 10,
        nickname: "",
        mobile: "",
        withdrawal_type: "",
        poolprofit_type: "",
        created_at: [],
        start_time: "",
        end_time: "",
      };
      this.getList();
    },
    getList() {
      let _this = this;
      _this.search.loading = true;
      _this.axios
        .get("/api/weishop/admin/plugin/poolprofit/withdrawal/index", {
          params: _this.search.post,
        })
        .then((res) => {
          if (res.code == 200) {
            _this.search.count_list = res.data.count_list || _this.search.count_list;
            _this.search.table = res.data.data || [];
            _this.search.total = res.data.total || 0;
          } else {
            eltips(res.msg, "error");
          }
          _this.search.loading = false;
        });
    },
    tablePageFun(e) {
      this.search.post.page = e;
      this.getList();
    },
    // 审核通过
    yesFun(e) {
      let _this = this;
      _this.$confirmDialog({
        title: "重要提示",
        content:
          '<div style="font-size:16px;display:flex;align-items: center;justify-content: center;">审核通过该笔提现, 是否继续?</div>',
        cancelText: "取消",
        confirmText: "确定",
        showClose: true,
        width: "500px",
        success: (res) => {
          if (res.confirm) {
            _this.axios
              .post("/api/weishop/admin/plugin/poolprofit/withdrawal/check/" + e, {
                status: 1,
                reason: "",
              })
              .then((res) => {
                if (res.code == 200) {
                  eltips(res.msg, "success");
                  _this.getList();
                } else {
                  eltips(res.msg, "error");
                }
              });
          }
        },
      });
    },
    // 审核拒绝（待审核）
    noFun(e) {
      this.type = "";
      this.reason.id = e;
      this.reason.text = "";
      this.reason.show = true;
    },
    // 拒绝打款（待打款）
    refusePay(e) {
      this.type = "refuse";
      this.reason.id = e;
      this.reason.text = "";
      this.reason.show = true;
    },
    addSureFun() {
      let _this = this;
      let url = this.type == "refuse"
        ? "/api/weishop/admin/plugin/poolprofit/withdrawal/refuse/"
        : "/api/weishop/admin/plugin/poolprofit/withdrawal/check/";
      this.axios
        .post(url + this.reason.id, {
          status: 2,
          reason: this.reason.text,
        })
        .then((res) => {
          if (res.code == 200) {
            eltips(res.msg, "success");
            _this.getList();
          } else {
            eltips(res.msg, "error");
          }
          _this.reason.show = false;
        });
    },
    // 手动打款
    yesHand(e) {
      let _this = this;
      _this.$confirmDialog({
        title: "重要提示",
        content:
          '<div style="font-size:16px;display:flex;align-items: center;justify-content: center;">确认已手动打款, 是否继续?</div>',
        cancelText: "取消",
        confirmText: "确定",
        showClose: true,
        width: "500px",
        success: (res) => {
          if (res.confirm) {
            _this.axios
              .post("/api/weishop/admin/plugin/poolprofit/withdrawal/pay/" + e)
              .then((res) => {
                if (res.code == 200) {
                  eltips(res.msg, "success");
                  _this.getList();
                } else {
                  eltips(res.msg, "error");
                }
              });
          }
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
* {
  font-size: 14px;
  color: #000;
}
/deep/.order_table tr td {
  padding: 10px;
}
/deep/.order_table tr td {
  border-left: none;
}
</style>
